/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { connect } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import withStyles from '@material-ui/core/styles/withStyles';
import { useUIDSeed } from 'react-uid';
import { Link } from 'react-router-dom';
import {
    object, shape, string, arrayOf,
} from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { getBrand } from '../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { determineCollectionPrefixPath } from '../../../../../../helpers/determineInternationalizationPath';

const styles = (theme) => ({
    outerCard: {
        padding: '20px',
        borderRadius: 'unset',
        boxShadow: '0 0 0 1px #636363',
    },
    linkText: {
        display: 'block',
        margin: 0,
        lineHeight: 1.5,
        color: '#212121',
        cursor: 'pointer',
        textShadow: '1px 1px 1px rgba(0, 0, 0, 0.004)',
        outline: 'none',
        textDecoration: 'none',
        padding: '3px 0 1px 0',
        fontSize: '14px',
        '&:hover': {
            color: theme.palette.colorPrimary,
        },
    },
    headerText: {
        '& p,& h2': {
            fontSize: '15px',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            paddingBottom: '4px',
            lineHeight: '1.5',
            margin: 0,
        },
    },
    link: {
        textDecoration: 'none',
    },
    title: {
        cursor: 'context-menu',
        fontSize: 14,
    },
});
const determinCollectionLink = (link, brand) => {
    if (brand?.code === '08F') {
        return determineCollectionPrefixPath(link, true);
    }
    if (brand?.code === 'CAN') {
        return determineCollectionPrefixPath(link, false);
    }
    if (brand?.code === 'PLA') {
        return determineCollectionPrefixPath(link, false);
    }
    return link;
};
const renderLinks = (classes, line, brand) => (((line?.href?.includes('/blog')) || (line?.href?.includes('/greenhouse')))
    ? <a href={`https://www.${brand?.domain}.com${line?.href}`} className={classes.linkText}>{line?.title}</a>
    : (
        <Link id="relatedSearchProduct" to={determinCollectionLink(line?.href, brand)} className={classes.linkText}>
            {line?.title}
        </Link>
    ));
const GraphqlCategoryRelatedBox = ({ classes, relatedData, brand }) => {
    const { title, link } = relatedData;
    const seed = useUIDSeed();
    if (typeof link !== 'undefined' && link !== null) {
        return (
            <Card className={classes.outerCard}>
                <Grid container direction="column">
                    <Grid item>
                        {/*
                            we want some headlines to be h2s for seo,
                            (normal string defaults to <p>, ## string returns <h2> from CMS)
                        */}
                        <ReactMarkdown
                            source={title}
                            skipHtml
                            className={classes.headerText}
                        />
                    </Grid>
                    <Grid item>
                        {link.map((line) => (
                            <Grid item key={seed(line)}>
                                {
                                    line?.href === ''
                                        ? <span className={classes.title}>{line?.title}</span>
                                        : renderLinks(classes, line, brand)
                                }
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Card>
        );
    }
    return null;
};

GraphqlCategoryRelatedBox.propTypes = {
    classes: object.isRequired,
    relatedData: shape({
        title: string.isRequired,
        link: arrayOf(shape({
            title: string.isRequired,
            href: string.isRequired,
        })).isRequired,
    }).isRequired,
    brand: shape({
        domain: string.isRequired,
    }).isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

export default connect(mapStateToProps, null)(withStyles(styles)(GraphqlCategoryRelatedBox));
